import { FaqSection } from '../../../../../api/types/faq-content-api';
import { buildFaqBreadcrumb } from '../Breadcrumb/breadcrumbHelper';
import { BLOCKS } from '@contentful/rich-text-types';
import { IFaqQuestionPageData } from './models';

export const buildQuestionPageData = (allSections: FaqSection[], sectionPath: string[]) => {
    const pageData: IFaqQuestionPageData = {
        faqSection: {
            sectionTitle: '',
            url: '',
            faqs: [],
            tags: [],
        },
        faq: {
            question: '',
            answer: {
                nodeType: BLOCKS.DOCUMENT,
                value: '',
                data: {},
                content: [],
                marks: [],
            },
            url: '',
        },
        otherTopics: [],
        breadcrumb: [],
        relatedQuestions: [],
    };
    pageData.faqSection = allSections?.find((r: { url: string }) => r.url.match(new RegExp(`${sectionPath[1]}$`, 'i')));
    pageData.faq = pageData.faqSection?.faqs?.find((faq) => faq.url.trim().match(new RegExp(`${sectionPath[2]}$`, 'i')));
    pageData.otherTopics = allSections?.filter((x) => x.sectionTitle !== pageData.faqSection?.sectionTitle);
    pageData.breadcrumb = buildFaqBreadcrumb(pageData.faqSection, pageData.faq);
    pageData.relatedQuestions = pageData.faqSection?.faqs.filter((x) => x.url !== pageData.faq?.url).splice(0, 3);
    return pageData;
};
